module.exports = "<div class=et-nores-page ng-show=showWhile> <div class=nores-content> <img src=" + require("/home/jenkins/workspace/test_BL_front/src/assets/images/Group.png") + " alt={{emptyText}}> <span>{{emptyText}}</span> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/noResPage/noResPage.html
// module id = 3oV9
// module chunks = 0